export const OTHER_SYSTEM = {
  LIGHT_STATE: {
    ON: 1,
    OFF: 0
  },
  HANDLE_STATUS: {
    ACTIVATED: 1,
    NOT_ACTIVATED: 0
  },
  PRESENCE: {
    PRESENT: 0,
    NOT_PRESENT: 1
  },
  STATUS: {
    TOILET_NOT_COMMUNICATION_ERROR: 0,
    TOILET_COMMUNICATION_ERROR: 1,
    TOILET_WATER_LEVEL_LOW: 1,
    TOILET_WASTE_WATER_TANK_FULL: 1,
    TOILET_BOWL_FULL: 1,
    TOILET_AIR_PRESSURE_LOW: 1,
    TOILET_VACUUM_FAILURE: 1,
    TOILET_PRESSURE_FAILURE: 1,
    TOILET_OUT_OF_ORDER: 1,
    TOILET_ACTIVE: 1,
    TOILET_INACTIVE: 0,
    TOILET_SOS_SIGNAL_ACTIVE: 1,
    TOILET_SOS_SIGNAL_INACTIVE: 0,
    FIRE: 0
  }
} as const;
